var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["catalog mb-20", "catalog-" + _vm.catalog_type] },
    [
      _c(
        "div",
        {
          staticClass:
            "cats flex flex-col lg:flex-row text-20px uppercase font-semibold",
        },
        [
          _vm._l(_vm.categories, function (category, index) {
            return [
              category.parent === 0
                ? _c(
                    "a",
                    {
                      key: "category_" + index,
                      class: [
                        "px-8 py-3",
                        { active: _vm.selected_cat == category.term_id },
                      ],
                      attrs: { href: "#" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.change_param("category", category.term_id)
                        },
                      },
                    },
                    [_vm._v("\n        " + _vm._s(category.name) + "\n      ")]
                  )
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: [
            "subcats text-white px-8 py-6",
            "bg-" + _vm.accent_color_class,
          ],
        },
        [
          _c(
            "div",
            { staticClass: "flex flex-wrap" },
            [
              _vm._l(_vm.categories, function (category, index) {
                return [
                  _vm.selected_cat == category.parent
                    ? _c(
                        "a",
                        {
                          key: "subcategory_" + index,
                          class: [
                            "w-1/2 md:w-1/4 lg:w-1/7 mb-3",
                            { active: _vm.selected_subcat == category.term_id },
                          ],
                          attrs: { href: "#" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.change_param(
                                "subcategory",
                                category.term_id
                              )
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(category.name) +
                              "\n        "
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              }),
            ],
            2
          ),
        ]
      ),
      _vm._v(" "),
      !_vm.loading
        ? _c("div", [
            _c("div", { staticClass: "filter bg-gray-3 px-8 py-6" }, [
              _vm.products.brands && _vm.products.brands.length
                ? _c("div", { staticClass: "mb-6" }, [
                    _c("div", { staticClass: "text-20px font-semibold mb-4" }, [
                      _vm._v("Prekės ženklas:"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex" },
                      _vm._l(_vm.products.brands, function (brand) {
                        return _c(
                          "label",
                          {
                            key: "brand_" + brand.ID,
                            staticClass:
                              "flex items-center mr-4 cursor-pointer",
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.selected_brands,
                                  expression: "selected_brands",
                                },
                              ],
                              staticClass: "form-checkbox text-white",
                              attrs: { type: "checkbox" },
                              domProps: {
                                value: brand.ID,
                                checked: Array.isArray(_vm.selected_brands)
                                  ? _vm._i(_vm.selected_brands, brand.ID) > -1
                                  : _vm.selected_brands,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.selected_brands,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = brand.ID,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.selected_brands = $$a.concat([
                                          $$v,
                                        ]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.selected_brands = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.selected_brands = $$c
                                  }
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "ml-2" }, [
                              _vm._v(_vm._s(brand.post_title)),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.products.attributes
                ? _c("div", [
                    _c("div", { staticClass: "text-20px font-semibold mb-4" }, [
                      _vm._v(_vm._s(_vm.app.string.filtruoti_pagal) + ":"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex -mx-2 md:-mx-4" },
                      _vm._l(
                        _vm.products.attributes,
                        function (terms, taxonomy) {
                          return _c(
                            "div",
                            {
                              key: "attr_" + terms[0].taxonomy,
                              staticClass: "md:-1/3 lg:w-1/6 px-2 md:px-4",
                            },
                            [
                              _c("MSelect", {
                                attrs: {
                                  terms: terms,
                                  taxonomy: terms[0].taxonomy,
                                  placeholder: taxonomy,
                                },
                              }),
                            ],
                            1
                          )
                        }
                      ),
                      0
                    ),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "products-list bg-white pt-16" }, [
              _c(
                "div",
                { staticClass: "flex flex-wrap md:-mx-2 lg:-mx-6 text-center" },
                _vm._l(_vm.products.products, function (product, index) {
                  return _c(
                    "a",
                    {
                      key: "product_" + index,
                      staticClass:
                        "w-full sm:w-1/2 md:w-1/3 lg:w-1/5 md:px-2 lg:px-6 mb-16 flex flex-col justify-between",
                      attrs: { href: product.post_link },
                    },
                    [
                      _c("div", [
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex items-center justify-center relative mb-3 min-h-150px",
                          },
                          [
                            product.post_thumbnail_url
                              ? _c("img", {
                                  attrs: {
                                    src: product.post_thumbnail_url,
                                    alt: "",
                                  },
                                })
                              : _c("img", {
                                  staticClass: "max-h-170px",
                                  attrs: { src: product.placeholder, alt: "" },
                                }),
                          ]
                        ),
                        _vm._v(" "),
                        _c("h2", [_vm._v(_vm._s(product.post_title))]),
                      ]),
                      _vm._v(" "),
                      product.talpa
                        ? _c("div", { staticClass: "mt-3" }, [
                            _vm._v(
                              _vm._s(product.talpa.name) +
                                " " +
                                _vm._s(product.mmu)
                            ),
                          ])
                        : _vm._e(),
                    ]
                  )
                }),
                0
              ),
            ]),
          ])
        : _c(
            "div",
            { staticClass: "min-h-440px flex items-center justify-center" },
            [
              _c("loader", {
                attrs: { loading: _vm.loading, color: _vm.accent_color },
              }),
            ],
            1
          ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "hidden md:block" },
        [
          _c("paginate", {
            attrs: {
              "page-count": _vm.page_count,
              "click-handler": _vm.change_page,
              "prev-text": this.app.string.atgal,
              "next-text": this.app.string.kitas,
              "container-class": "pagination",
            },
            model: {
              value: _vm.current_page,
              callback: function ($$v) {
                _vm.current_page = $$v
              },
              expression: "current_page",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "md:hidden" },
        [
          _c("paginate", {
            attrs: {
              "page-count": _vm.page_count,
              "click-handler": _vm.change_page,
              "margin-pages": 1,
              "prev-text": "<",
              "next-text": ">",
              "container-class": "pagination",
            },
            model: {
              value: _vm.current_page,
              callback: function ($$v) {
                _vm.current_page = $$v
              },
              expression: "current_page",
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/kinfirm/Sites/mvgroup/wp-content/themes/mvgroup/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/kinfirm/Sites/mvgroup/wp-content/themes/mvgroup/node_modules/vue-loader/lib?{}!./scripts/autoload-components/catalog-production.vue?vue&type=template&id=685dcbb9&
// module id = 638
// module chunks = 0